import { useCallback, useEffect, useRef, useState } from "react";

const MISSING_PRACTICES_HIGHLIGHT_DURATION_MS = 1000;
const MISSING_PRACTICE_CELL_SELECTOR = ".all-fields-data-table-view-cell-highlighted";

export const useMissingPracticesHighlight = () => {
  const [highlightedMissingRowKey, setHighlightedMissingRowKey] = useState<string | null>(null);
  const highlightClearTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const toggleHighlightMissingPractices = useCallback((rowKey: string) => {
    clearTimeout(highlightClearTimeoutRef.current);
    setHighlightedMissingRowKey((previous) => {
      if (previous === rowKey) return null;
      highlightClearTimeoutRef.current = setTimeout(() => setHighlightedMissingRowKey(null), MISSING_PRACTICES_HIGHLIGHT_DURATION_MS);
      requestAnimationFrame(() => {
        document.querySelector(MISSING_PRACTICE_CELL_SELECTOR)?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      });
      return rowKey;
    });
  }, []);

  useEffect(() => () => clearTimeout(highlightClearTimeoutRef.current), []);

  return { highlightedMissingRowKey, toggleHighlightMissingPractices };
};
